import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useRouter } from '@loyalup/core';

import s from './Link.module.css';

const Lnk = ({ children, className, ...props }) => {
  const { Link } = useRouter();
  return (
    <Link className={cn(s.root, className)} {...props}>
      {children}
    </Link>
  );
};

Lnk.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default React.memo(Lnk);
